import { EntityType } from '@frontend/common';
import { MultiObjectSelectInput } from '@frontend/components/basic-forms';
import { CommonMessage, useLocale } from '@frontend/lang';
import { ProductClient } from '@frontend/product/api';
import { defaultMapWithAttributes } from '@frontend/product/badge';
import { IProduct } from '@frontend/product/types';
import { FormattedMessage } from 'react-intl';

import UpdateModal from '../../../../modal/update-modal/update-modal.component';
import { useLinkProductsModal } from './link-products-modal.controller';

export interface LinkProductsModalProps {
    groupId: string;
}

export const LinkProductsModal = (props: LinkProductsModalProps) => {
    const viewProps = useLinkProductsModal(props);
    const { locale } = useLocale();

    return (
        <UpdateModal<{ success: boolean }, { product_ids: string[] }>
            order={[]}
            label={
                <div className='flex gap-2'>
                    <span>{CommonMessage.BUTTONS.LINK}</span>
                    <span>{CommonMessage.OBJECTS.PRODUCT.PLURAL}</span>
                </div>
            }
            type={EntityType.MEMBER}
            values={viewProps.formValues}
            onSubmit={viewProps.onSubmit}
            successMessageOverwrite={
                <FormattedMessage
                    id='category-detail.link-products-modal.success-message'
                    defaultMessage='Products linked successfully.'
                />
            }
            append={
                <MultiObjectSelectInput<IProduct, string>
                    id='link-products-modal-products'
                    label={CommonMessage.OBJECTS.PRODUCT.PLURAL}
                    onChange={(v) => viewProps.setSelectedProducts(v.map((prod) => prod.id))}
                    value={viewProps.selectedProducts}
                    fetch={(arg) => ProductClient.fetchProductsNotInGroup(viewProps.currentAccount, props.groupId, arg)}
                    itemLabel={(prod: IProduct) => defaultMapWithAttributes(prod, locale)}
                    required
                />
            }
        />
    );
};
